import { render, staticRenderFns } from "./EssaysIndex.vue?vue&type=template&id=70f156fb&scoped=true"
import script from "./EssaysIndex.vue?vue&type=script&lang=js"
export * from "./EssaysIndex.vue?vue&type=script&lang=js"
import style0 from "./EssaysIndex.vue?vue&type=style&index=0&id=70f156fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f156fb",
  null
  
)

export default component.exports